import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import $xc from '@/manage/index'

const login = resolve => require(['@/pages/login'], resolve)
const register = resolve => require(['@/pages/register'], resolve)
const found = resolve => require(['@/pages/found'], resolve)
const reset = resolve => require(['@/pages/reset'], resolve)
const about = resolve => require(['@/pages/about'], resolve)
const focus = resolve => require(['@/pages/focus'], resolve)
const error = resolve => require(['@/pages/error'], resolve)

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/found',
      name: 'found',
      component: found
    },
    {
      path: '/reset',
      name: 'reset',
      component: reset
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/focus',
      name: 'focus',
      component: focus
    },
    {
      path: '*',
      name: 'error',
      component: error
    }
  ]
})

router.beforeEach((to, from, next) => {
	store.commit('updateLoadingStatus', {isLoading: true})
	console.log(to)
	if ($xc.cookie.get('token') && to.name !== 'login'&&to.name !== 'register') {
		location.href = $xc.protocol+'member.'+$xc.location+'/mobile/#/'
	} else {
		next()
	}
})

router.afterEach((to, from) => {
	store.commit('updateLoadingStatus', {isLoading: false})
	if (from.name === 'reset') { //不在重置页面销毁信息
  	store.commit('updatePhoneNum', {phone: '', userId: ''})
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js